<script setup>
import { useStore } from "vuex";
import API from "../../../api/api-main";
import { ref, onBeforeMount } from "vue";
import { useToast } from "primevue/usetoast";
import { getCurrentInstance } from "vue";

const { proxy } = getCurrentInstance();
const toast = useToast();
const emit = defineEmits(["dataReturn"]);
const store = useStore();
const GoodsForReturns = ref([]);
const Products = ref([]);
const keySearchProducts = ref("");

onBeforeMount(() => {
  emit("dataReturn", []);
});
const fetchAllProducts = async () => {
  try {
    const res = await API.get(
      `Item/getItemOrBarCode/${keySearchProducts.value}?branchId=${store.state.auth.user.appUser.branchId}`
    );
    Products.value = res.data;
    emit("dataReturn", []);
  } catch (error) {
    console.log(error);
  }
};
const addItem = (data) => {
  if (typeof data != "object") return;
  if (GoodsForReturns.value.length > 0) {
    const checkProduct = GoodsForReturns.value.filter((val) => {
      const is_check = val.serialBatchNumber == data.serialBatchNumber;
      return is_check;
    });
    if (checkProduct.length > 0) {
      if (checkProduct[0].quantity >= checkProduct[0].onhand) {
        proxy.$notify("E", "Số lượng tồn kho không đủ", toast);
        return;
      }
      checkProduct[0].quantity += 1;
      return;
    }
    data.quantity = 1;

    GoodsForReturns.value.push(data);
    emit("dataReturn", GoodsForReturns.value);
    return;
  }
  data.quantity = 1;
  GoodsForReturns.value.push(data);
  emit("dataReturn", GoodsForReturns.value);
};
const formatPrice = (price) => {
  return new Intl.NumberFormat("en-US").format(price);
};

const deleteProduct = (item) => {
  const serialBatchNumber = item.serialBatchNumber;
  if (GoodsForReturns.value.length > 0) {
    GoodsForReturns.value = GoodsForReturns.value.filter((item) => {
      return item.serialBatchNumber != serialBatchNumber;
    });
  }
};
</script>
<template>
  <div class="card  shadow-1 h-30rem">
    <div class="flex flex-column gap-5">
      <div class="flex justify-content-start gap-3 align-items-center">

      </div>
      <DataTable scrollable scrollHeight="300px" :value="GoodsForReturns" showGridlines stripedRows>
        <template #header>
          <div class="flex align-items-center justify-content-between">
            <InputGroup class="w-30rem">
              <AutoComplete placeholder="Tìm hàng đổi trả..." v-model="keySearchProducts"
                @change="addItem(keySearchProducts)" @keyup.enter="addItem(keySearchProducts)" optionLabel="itemName"
                :suggestions="Products" @complete="fetchAllProducts" class="w-30rem">
                <template #option="slotProps">
                  <div class="border-gray-200 border-bottom-1 pb-2">
                    <div class="flex flex-column gap-2 w-full">
                      <div class="flex justify-content-between w-full">
                        {{ slotProps.option.itemName }}
                        <strong class="text-primary">{{ slotProps.option.price }}đ</strong>
                      </div>
                      <div class="flex justify-content-between w-full">
                        <strong>{{ slotProps.option.itemCode }}</strong>
                        <span><strong>Lô/Serial: </strong>{{ slotProps.option.serialBatchNumber }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </AutoComplete>
              <InputGroupAddon>
                <i class="pi pi-search"></i>
              </InputGroupAddon>
            </InputGroup>
            <strong>Đổi hàng</strong>

          </div>
        </template>
        <template #empty>
          <div class="p-2 text-center">Vui lòng chọn sản phẩm</div>
        </template>
        <Column field="itemCode" header="Mã sản phẩm" style="min-width: 150px"></Column>
        <Column field="itemName" header="Tên sản phẩm" style="min-width: 150px"></Column>
        <Column field="serialBatchNumber" header=" Lô/Serial" style="min-width: 150px">
          <template #body="slotProps">
            <InputText v-if="!slotProps.data.serialBatchNumber"></InputText>
            <span v-if="slotProps.data.serialBatchNumber">{{
              slotProps.data.serialBatchNumber
            }}</span>
          </template>
        </Column>
        <Column field="quantity" header="Số lượng" style="min-width: 150px">
          <template #body="slotProps">
            <InputNumber :pt="{
              input: { root: { style: 'width: 4rem', class: 'text-center' } },
            }" @input="onQuantityChange($event, slotProps.data)" v-model="slotProps.data.quantity" :min="1"
              :max="slotProps.data.onhand" inputId="horizontal-buttons" showButtons buttonLayout="horizontal">
              <template #incrementbuttonicon>
                <span class="pi pi-plus" />
              </template>
              <template #decrementbuttonicon>
                <span class="pi pi-minus" />
              </template>
            </InputNumber>
          </template>
        </Column>
        <Column field="price" header="Đơn giá" style="min-width: 150px">
          <template #body="slotProps">
            <div>
              <span>{{ formatPrice(slotProps.data.price) }}</span>
            </div>
          </template>
        </Column>
        <Column field="orderTotal" header="Trọng lượng vàng" style="min-width: 150px"></Column>
        <Column field="goldAmount" header="Tiền vàng" style="min-width: 150px"></Column>
        <Column field="weightStones" header="Trọng lượng đá" style="min-width: 150px"></Column>
        <Column field="stonesAmount" header="Tiền đá" style="min-width: 150px"></Column>
        <Column field="labourAmount" header="Tiền công" style="min-width: 150px"></Column>
        <Column field="price" header="Thành tiền" style="min-width: 150px">
          <template #body="slotProps">
            {{ formatPrice(slotProps.data.price) }}
          </template>
        </Column>
        <Column field="" header="Hành động" style="min-width: 150px">
          <template #body="slotProps">
            <div class="flex align-items-center gap-2">
              <Button @click="openDetailPrdDialog(slotProps.data)" icon="pi pi-eye" text rounded></Button>
              <Button @click="deleteProduct(slotProps.data)" icon="pi pi-trash" text rounded></Button>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
